import { IBieuDoRequest } from "../../model/request/bieu-do/IBieuDoRequest";
import { apiClient } from "../apiClient";
export const BIEU_DO_ENDPOINT = "bieu-do";

export const bieuDoApi = {
  Select: (request: IBieuDoRequest) =>
    apiClient.post(`${BIEU_DO_ENDPOINT}`, request),
};
